<form
  [formGroup]="form"
  locktonAppsFormGroupValidation
  #formGroupValidation="validation"
  (ngSubmit)="onSubmit()"
>
  <div class="container-fluid">
    <div class="mw-md mx-auto">
      <div class="mb-2">
        <h2 class="mat-subtitle-1" i18n>Contact details</h2>
      </div>

      <div class="vstack gap-1">
        <ng-container *ngIf="loaded; else detailsLoading">
          <lui-form-field *ngIf="clientId">
            <lui-label i18n
              >Is this contact a primary contact for this client?</lui-label
            >
            <lui-select-box-group formControlName="isPrimary">
              <div class="hstack gap-1">
                <lui-select-box [value]="true" i18n>Yes</lui-select-box>
                <lui-select-box [value]="false" i18n>No</lui-select-box>
              </div>
            </lui-select-box-group>
          </lui-form-field>

          <!-- First name -->
          <mat-form-field *ngIf="showClientIdControl">
            <mat-label i18n>Client</mat-label>
            <lui-form-field-indicator></lui-form-field-indicator>
            <input
              matInput
              formControlName="clientId"
              [matAutocomplete]="autocomplete"
            />

            <span matSuffix *ngIf="!clientsLoaded">
              <lui-circular-progress
                mode="indeterminate"
                diameter="20"
                color="primary"
              ></lui-circular-progress>
            </span>

            <mat-autocomplete
              #autocomplete
              [displayWith]="clientDisplayWith.bind(this)"
            >
              <mat-option [value]="option.id" *ngFor="let option of clients">
                {{ option.clientData.insuredName }}
              </mat-option>
            </mat-autocomplete>
            <mat-error>{{
              formGroupValidation.getMessageForControl('clientId')
            }}</mat-error>
          </mat-form-field>

          <!-- First name -->
          <mat-form-field>
            <mat-label i18n>First name</mat-label>
            <lui-form-field-indicator></lui-form-field-indicator>
            <input matInput formControlName="givenName" type="text" />
            <mat-error>{{
              formGroupValidation.getMessageForControl('givenName')
            }}</mat-error>
          </mat-form-field>

          <!-- Last name -->
          <mat-form-field>
            <mat-label i18n>Last name</mat-label>
            <lui-form-field-indicator></lui-form-field-indicator>
            <input matInput formControlName="surname" type="text" />
            <mat-error>{{
              formGroupValidation.getMessageForControl('surname')
            }}</mat-error>
          </mat-form-field>

          <!-- Email -->
          <mat-form-field>
            <mat-label i18n>Email</mat-label>
            <lui-form-field-indicator></lui-form-field-indicator>
            <input matInput formControlName="email" type="email" />
            <span matSuffix *ngIf="emailControl && emailControl.pending">
              <lui-circular-progress
                mode="indeterminate"
                diameter="20"
                color="primary"
              ></lui-circular-progress>
            </span>
            <mat-error>{{
              formGroupValidation.getMessageForControl('email')
            }}</mat-error>
          </mat-form-field>

          <!-- Phone -->
          <mat-form-field>
            <mat-label i18n>Phone</mat-label>
            <lui-form-field-indicator></lui-form-field-indicator>
            <input
              matInput
              formControlName="phoneNumber"
              type="tel"
              mask="00009999999999000"
            />
            <mat-error>{{
              formGroupValidation.getMessageForControl('phoneNumber')
            }}</mat-error>
          </mat-form-field>

          <!-- Language -->
          <lui-form-field
            *ngIf="showLanguageControl || !form.get('language')?.valid"
          >
            <lui-label i18n>Language preference</lui-label>
            <lui-select-box-group formControlName="language">
              <div class="row g-1">
                <div
                  class="col-12 col-sm-6"
                  *ngFor="let language of availableLanguages"
                >
                  <lui-select-box class="w-100" i18n [value]="language.code">
                    {{ language.description }}
                  </lui-select-box>
                </div>
              </div>
            </lui-select-box-group>
          </lui-form-field>
        </ng-container>
      </div>
    </div>
  </div>

  <div
    *ngIf="showAddProducts && !isPrimaryContact && clientId"
    [@slideInTopOpenClose]="isPrimaryContact ? 'open' : null"
  >
    <ng-container *ngIf="loaded && policiesLoaded; else policiesLoading">
      <ng-container *ngIf="policies.length">
        <div class="my-3 my-md-5">
          <mat-divider></mat-divider>
        </div>

        <div class="container-fluid">
          <div class="mw-md mx-auto">
            <div class="mb-3">
              <h2 class="mat-h3" i18n>Assign policies</h2>
            </div>

            <la-contact-product-assignment
              [control]="policyIdsControl"
              [policies]="policies"
              [loaded]="loaded && policiesLoaded"
            ></la-contact-product-assignment>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</form>

<ng-template #detailsLoading>
  <lui-skeleton
    *ngFor="let control of form.controls | keyvalue | slice : 0 : 5"
    height="53"
    class="mb-2_5"
  ></lui-skeleton>
</ng-template>

<ng-template #policiesLoading>
  <div class="mb-2">
    <lui-skeleton height="120"></lui-skeleton>
  </div>
  <lui-skeleton
    *ngFor="let control of form.controls | keyvalue | slice : 0 : 2"
    height="53"
    class="mb-2_5"
  ></lui-skeleton>
</ng-template>
